export default "__VITE_ASSET__35d7102e__"